export default {
	state: {
		clientDetailInfo: {
			loading: false,
			data: {
				sl_xs: 15,
				subs: [
					{
						col_idx: 0,
						index_no: 0,
						title: '我是显示字段',
					},
					{
						col_idx: 1,
						index_no: 1,
						title: '我是显示字段1',
					},
				],
			},
		},
		clientDetailInfoForSelect: {
			loading: false,
			data: [
				{ col_idx: 0, title: 'a' },
				{ col_idx: 1, title: 'b' },
			],
		},
	},
	mutations: {
		reqeustClient(state) {
			state.clientDetailInfo.loading = true;
		},
		successClient(state, data) {
			state.clientDetailInfo.loading = false;
			state.data = data;
		},
		requestSelect(state) {
			state.clientDetailInfoForSelect.loading;
		},
		successSelect(state, data) {
			state.clientDetailInfoForSelect.loading = false;
			state.clientDetailInfoForSelect.data = data;
		},
	},
	actions: {
		async getClientDetailInfo({ commit }, params) {
			commit('reqeustClient');
			const res = await a.api('findKhdList', params);
			commit('successClient', res.result);
		},
		async getClientDetailForSelect({ commit }, params) {
			commit('requestSelect');
			const res = await a.api('tplFindSelectVal', params);
			commit('successSelect', res.result);
		},
	},
};
